<template>
    <b-modal :id="modalID" @shown="onShown" title="Choose filters" class="modal-primary" @hidden="
        $emit('date-picker-modal-emit', from(changedDateFrom), to(changedDateTo), selectedProduct, selectedManufacturer)
        " @ok="
        $emit('date-picker-modal-emit', from(changedDateFrom), to(changedDateTo), selectedProduct, selectedManufacturer),
        fetchData()
        ">
        <b-form>
            <b-form-group label="From" label-for="changedDateFrom" :label-cols="3">
                <datepicker use-utc format="MM/dd/yyyy" :bootstrap-styling="true" v-model="changedDateFrom"
                    name="changedDateFrom"></datepicker>
            </b-form-group>
            <b-form-group label="To" label-for="changedDateTo" :label-cols="3">
                <datepicker use-utc format="MM/dd/yyyy" :bootstrap-styling="true" v-model="changedDateTo"
                    name="changedDateTo"></datepicker>
            </b-form-group>
            <b-form-group label="Product Model" :label-cols="3">
                <b-input-group size="xl">
                   <b-form-input type="search" v-model="searchProductTerm" name="searchProductTerm" @input="handleProductInput" placeholder="Type to Search" @blur="hideProducts" style="width: 83%;">
                    </b-form-input>
                    <b-list-group v-if="showProductsResults" style="position: absolute; width: 83%; max-height: 200px; overflow-y: auto; margin-top: 36px; color: black; z-index: 50;">
                    <b-list-group-item v-for="(product, i) in products" :key="product.id + i" @click="selectProduct(product)">
                        {{ product.name }}
                    </b-list-group-item>
                    </b-list-group>
                    <b-input-group-prepend v-if="loadingProduct">
                        <b-spinner small style="margin-left: -25px; margin-top: 10px; z-index: 10;"></b-spinner>
                    </b-input-group-prepend>
                    <b-input-group-append>
                        <b-button  style="border-radius: 4px;" @click="clearProductSelection">Clear</b-button>
                    </b-input-group-append>
                </b-input-group>
            </b-form-group>
            <b-form-group label="Third Party Client" :label-cols="3">
                <b-input-group size="xl">
                   <b-form-input type="search" v-model="searchManufacturerTerm" name="searchManufacturerTerm" @input="handleManufacturerInput" placeholder="Type to Search" @blur="hideManufacturers" style="width: 83%;">
                    </b-form-input>
                    <b-list-group v-if="showManufacturersResults" style="position: absolute; width: 83%; max-height: 200px; overflow-y: auto; margin-top: 36px; color: black; z-index: 50;">
                    <b-list-group-item v-for="(manufacturer, i) in manufacturers" :key="manufacturer.id + i" @click="toggleManufacturerSelection(manufacturer)" :active="isSelected(manufacturer)">
                        {{ manufacturer.name }}
                    </b-list-group-item>
                    </b-list-group>
                    <b-input-group-prepend v-if="loadingManufacturer">
                            <b-spinner small style="margin-left: -25px; margin-top: 10px; z-index: 10;"></b-spinner>
                        </b-input-group-prepend>
                    <b-input-group-append>
                        <b-button style="border-radius: 4px;" @click="clearManufacturerSelection">Clear</b-button>
                    </b-input-group-append>
                    <div v-if="selectedManufacturer.length > 0" class="selected-manufacturers">
                        <span v-for="(manufacturer, index) in selectedManufacturer" :key="index" class="selected-manufacturer">
                            {{ manufacturer.name }}
                            <i class="icon-close" @click.stop="removeManufacturer(manufacturer)"></i>
                        </span>
                    </div>
                </b-input-group>
            </b-form-group>
        </b-form>
    </b-modal>
</template>
<script>
import Datepicker from "vuejs-datepicker";
import { from, to } from "../../utils/Utils";
import _ from 'lodash';

export default {
    name: "DateModal",
    components: {
        Datepicker
    },
    props: ["fetchData", "dateFrom", "dateTo", "modalID"],
    data: function () {
        return {
            from: from,
            to: to,
            changedDateFrom: this.dateFrom,
            changedDateTo: this.dateTo,
            searchProductTerm: '',
            products: [],
            selectedProduct: null,
            showProductsResults: false,
            searchManufacturerTerm: '',
            manufacturers: [],
            selectedManufacturer: [],
            showManufacturersResults: false,
            loadingProduct: false,
            loadingManufacturer: false
        };
    },
    methods: {
        onShown() {
            this.changedDateFrom = this.dateFrom;
            this.changedDateTo = this.dateTo;
            this.clearProductSelection();
            this.clearManufacturerSelection();
            this.selectedManufacturer = [];
        },
        handleProductInput: _.debounce(function () {
            if (this.searchProductTerm.length >= 2) {
                this.loadingProduct = true;
                this.getProducts(this.searchProductTerm);
            }
        }, 300),
        handleManufacturerInput: _.debounce(function () {
            if (this.searchManufacturerTerm.length >= 2) {
                this.loadingManufacturer = true;
                this.getManufacturers(this.searchManufacturerTerm);
            }
        }, 300),
        getProducts(product) {
            let params = {
                name: product
            };
            this.$http.get(`${process.env.VUE_APP_TRACKER_BASE}/api/teleste/product_models.php`, { params }).then(
                res => {
                    this.products = res.data
                    this.showProductsResults = res.data.length > 0 && this.searchProductTerm.length > 0;
                }).catch(error => {
                    console.error('Error fetching products:', error);
                })
                .finally(() => {
                    this.loadingProduct = false;
                });
        },
        getManufacturers(manufacturer) {
            let params = {
                name: manufacturer
            };
            this.$http.get(`${process.env.VUE_APP_TRACKER_BASE}/api/teleste/third_party.php`, { params }).then(
                res => {
                    this.manufacturers = res.data
                    this.showManufacturersResults = res.data.length > 0 && this.searchManufacturerTerm.length > 0;
                }).catch(error => {
                    console.error('Error fetching manufacturers:', error);
                })
                .finally(() => {
                    this.loadingManufacturer = false;
                });
        },
        selectProduct(product) {
            this.selectedProduct = product;
            this.searchProductTerm = product.name; // Update search term to show selected product
            this.showProductsResults = false; // Hide search results
        },
        hideProducts() {
            setTimeout(() => {
                this.showProductsResults = false; // Hide search results
            }, 200)
        },
        clearProductSelection() {
            this.selectedProduct = null;
            this.searchProductTerm = ''; // Clear search term
        },
        selectManufacturer(manufacturer) {
            this.selectedManufacturer = manufacturer;
            this.searchManufacturerTerm = manufacturer.name; // Update search term to show selected product
            this.showManufacturersResults = false; // Hide search results
        },
        toggleManufacturerSelection(manufacturer) {
            const index = this.selectedManufacturer.findIndex(m => m.id === manufacturer.id);
            if (index === -1) {
                this.selectedManufacturer.push(manufacturer);
            } else {
                this.selectedManufacturer.splice(index, 1);
            }
            this.showManufacturersResults = false; // Hide search results
        },
        isSelected(manufacturer) {
            return this.selectedManufacturer.some(m => m.id === manufacturer.id);
        },
        clearManufacturerSelection() {
            this.searchManufacturerTerm = ''; // Clear search term
        },
        hideManufacturers() {
            setTimeout(() => {
                this.showManufacturersResults = false; // Hide search results
            }, 200)
        },
        removeManufacturer(manufacturer) {
            const index = this.selectedManufacturer.findIndex(m => m.id === manufacturer.id);
            if (index !== -1) {
                this.selectedManufacturer.splice(index, 1);
            }
        }
    },
};
</script>

<style scoped>

.input-group {
    width: auto;
}

.selected-manufacturers {
    display: flex;
    flex-wrap: wrap;
    margin-top: 10px;
}

.selected-manufacturer {
    display: flex;
    align-items: center;
    background-color: #515b65;
    border-radius: 4px;
    padding: 5px;
    margin: 2px;
}

.selected-manufacturer .remove-icon  {
    cursor: pointer;
    margin-left: 5px;
}

.icon-close {
  cursor: pointer;
  margin-left: 8px; /* Adds space between the name and the close icon */
}
</style>
